// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_NLQ","cls2":"ReferenceEvaluationPage-cls2_y6L ReferenceEvaluationPage-cls1_NLQ","shimmer":"ReferenceEvaluationPage-shimmer_r4W"};